
import Vue from 'vue'
import { EntityService } from '@/services/entity.service'
import { validationMixin } from 'vuelidate'
import { integer } from 'vuelidate/lib/validators'
import mixin from './invoiceStatus.mixin'

const entityService = new EntityService()

export default Vue.extend({
  name: 'ProjectsEdit',
  mixins: [validationMixin, mixin],
  validations: {
    form: {
      amount: { integer }
    }
  },
  props: ['value', 'editEntity'],
  data: () => ({
    entity: 'invoices',
    isLoading: false,
    projects: [],
    statusList: [],
    form: {
      code: '',
      name: '',
      amount: 0,
      project: {},
      status: ''
    }
  }),
  async created () {
    this.projects = await entityService.getList('projects')
    this.statusList = this.getInvoiceStatusList()
    this.form = {
      code: this.editEntity.code,
      name: this.editEntity.name,
      amount: this.editEntity.amount,
      project: this.editEntity.project ? this.editEntity.project.id : null,
      status: this.editEntity.status
    }
  },
  methods: {
    toggleModal (value: boolean) {
      this.$emit('input', value)
    },
    async save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.isLoading = true
        await entityService.updateEntity(this.editEntity.id, this.entity, this.form)
        this.isLoading = false
        this.$emit('input', false)
      }
    },
    getError: function (element: string) {
      const obj = this.$v.form[element] || { $error: '' }
      if (obj.$error) return 'Campo inválido'
    }
  }
})
